
import { MENU_ITEM_REMOVED } from "@/constants/MixpanelEvents.js";
import { mapActions, mapGetters } from "vuex";
import MenuItemRowWithPriceAndSwitch from "./menu-item-row-with-price-and-switch.vue";
import MenuItemModificationUpdateBtn from "./menu-item-modification-update-btn.vue";
import emptyPublishMenuImage from "~/assets/images/emptyPublishMenuImage.svg";
export default {
  components: {
    MenuItemModificationUpdateBtn,
    MenuItemRowWithPriceAndSwitch
  },
  data() {
    return {
      selectedItem: {},
      deleteLoading: false,
      showDeleteConfirmationDialog: false,
      emptyPublishMenuImage
    };
  },
  computed: {
    ...mapGetters("menu", [
      "getPendingAvailabilitySyncItems",
      "getPendingCatalogueSyncItems",
      "getPendingCatalogueSyncAddons",
      "getPendingCatalogueSyncCombos"
    ]),
    groupedItems() {
      return [
        {
          title: "Newly Added / Modified Item",
          items: this.getPendingCatalogueSyncItems
        },
        {
          title: "Newly Added Combo",
          items: this.getPendingCatalogueSyncCombos
        },
        {
          title: "Newly Added Add-on",
          items: this.getPendingCatalogueSyncAddons
        }
      ].filter((group) => group.items.length > 0);
    },
    getAllPendingSyncs() {
      return [
        ...this.getPendingCatalogueSyncItems,
        ...this.getPendingCatalogueSyncAddons,
        ...this.getPendingCatalogueSyncCombos
      ];
    }
  },
  methods: {
    ...mapActions("menu", [
      "deleteMenuItem",
      "deleteAddon",
      "deleteCombo",
      "getAddons",
      "getCombosList"
    ]),
    initDelete(item) {
      this.selectedItem = item;
      this.showDeleteConfirmationDialog = true;
    },
    initEdit(item) {
      if (item.combo_items) {
        this.$router.push("/menu/" + item.id + "/combo");
      } else if (item.variants) {
        this.$router.push("/menu/" + item.id + "/item");
      } else {
        this.$router.push("/menu/" + item.id + "/addons");
      }
    },
    async handleDeleteMenuItem(item) {
      this.showDeleteConfirmationDialog = false;
      this.deleteLoading = true;
      let response = {};
      try {
        if (item.combo_items) {
          response = await this.deleteCombo(item.id);
          await this.getCombosList(true);
        } else if (item.variants) {
          response = await this.deleteMenuItem(item.id);
        } else {
          response = await this.deleteAddon(item.id);
          await this.getAddons(true);
        }
        if (response.status === 200) {
          this.mixPanelTrackEvent(MENU_ITEM_REMOVED);
          this.$nuxt.$emit("show-toast", {
            text: "Item successfully deleted",
            color: "success darken-2",
            icon: "done",
            flat: true
          });
        } else {
          this.$nuxt.$emit("show-error-toast", response);
        }
      } catch (error) {
        this.isActive = !this.isActive;
        this.$nuxt.$emit("show-error-toast", error);
      }
      this.deleteLoading = false;
    }
  }
};
